import React from 'react';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import {requestChangeLanguage} from '../../actions/action_settings';
import LanguageItem from './LanguageItem';
import translations from '../../../res/translations';

const languages = Object.keys(translations);
languages.sort();

class LanguageButton extends React.Component {
    constructor(props) {
        super(props);
        this.select = this.select.bind(this);
    }

    select(language) {
        this.props.requestChangeLanguage(language);
    }

    render() {
        const current = this.props.intl.locale;
        return (
            <ul className="language-switcher list-inline">
                {languages.map((language) => <LanguageItem key={language} language={language} onClick={this.select} current={current} />)}
            </ul>
        );
    }
}

export default injectIntl(connect(undefined, {requestChangeLanguage})(LanguageButton));
